import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ ...args }) {
    super(args)
    const child = this.getComponentWithVModel('yes-no')
    this.children = [child]
  }
}
